import React, { PropTypes } from 'react'
import { connect } from 'react-redux'

import Loading from 'components/Loading'

import FormContainer from './form-container'

const OfferingsEdit = ({ __item, params }) => {
  const id = Number(params.id)
  if (!__item || __item.get('id') !== id) {
    return <Loading />
  }

  return (
    <FormContainer item={__item} />
  )
}

OfferingsEdit.propTypes = {
  __item: PropTypes.object,
  params: PropTypes.object,
}

function mapStateToProps(state, ownProps) {
  const id = Number(ownProps.params.id)
  return {
    __item: state.offering.getIn(['item', id]),
  }
}

export default connect(mapStateToProps)(OfferingsEdit)



// WEBPACK FOOTER //
// ./src/containers/Setup/Offerings/edit.js